import React from "react";
import { fetchShipmentIntegrations } from "~/services";
import PriceSetupCard from "./PriceSetupCard";
import CountryFlag from "~/components/CountryFlag.jsx";
import { serviceIsSuccessfullyFetched, useServiceHook } from "rylak-common";
import { ENTITY_TYPE } from "~/constants";
import EntityListCards from "~/components/entityAction/EntityListCards.js";
import { globalPriceSetupExists, globalPriceSetupIsNotLastSetup } from "~/cores/priceSetupCore.js";
import { TurnrActionAlert, TurnrWarningAlert } from "~/components/alerts/TurnrAlert.jsx";

function GlobalInfoIcon() {
    return (
        <div
            style={{
                width: "20px",
                height: "20px",
                display: "inline-block",
                marginBottom: "-5px",
                marginTop: "-3px",
            }}
        >
            <CountryFlag countryCode={"GLOBAL"} />
        </div>
    );
}

function PreEntityListComponent({ entitiesServiceData }) {
    const priceSetups = entitiesServiceData?.data;
    return (
        <>
            {serviceIsSuccessfullyFetched(entitiesServiceData) && !globalPriceSetupExists(priceSetups) && (
                <TurnrActionAlert fullWidth className={"mb2"}>
                    <div>
                        You do not have a global Price Setup <GlobalInfoIcon />. It's good practice to have a global setup with the lowest priority to make sure every customer is able to make a return
                    </div>
                </TurnrActionAlert>
            )}
            {serviceIsSuccessfullyFetched(entitiesServiceData) && globalPriceSetupIsNotLastSetup(priceSetups) && (
                <TurnrWarningAlert fullWidth className={"mb2"}>
                    <div>
                        Your global Price Setup <GlobalInfoIcon />
                        &nbsp; does not have the lowest priority. Note that this results in that any Price Setup with lower priority will never be eligible for any customer
                    </div>
                </TurnrWarningAlert>
            )}
        </>
    );
}

function PriceSetupEntityContentComponent(props) {
    const { entity } = props;
    return <PriceSetupCard {...props} priceSetup={entity} />;
}

export default function PriceSetups(props) {
    const { appProps, shopAddressesServiceData } = props;

    let { serviceData: shipmentIntegrationsServiceData, fetchServiceData: fetchShipmentIntegrationsFn } = useServiceHook({
        appProps,
        fetchRequested: true,
        fetchFn: fetchShipmentIntegrations,
    });

    function onPriceSetupUpdate() {
        fetchShipmentIntegrationsFn();
    }

    return (
        <div>
            <EntityListCards
                appProps={appProps}
                entityType={ENTITY_TYPE.PRICE_LIST}
                fetchEntitiesQueryParams={{ sort: "priority" }}
                onUpdate={onPriceSetupUpdate}
                PreEntityListComponent={PreEntityListComponent}
                EntityContentComponent={PriceSetupEntityContentComponent}
                entityContentComponentProps={{
                    ...props,
                    shopAddressesServiceData: shopAddressesServiceData,
                    shipmentIntegrationsServiceData: shipmentIntegrationsServiceData,
                    onPriceSetupUpdate: onPriceSetupUpdate,
                }}
            />
        </div>
    );
}
